/**
 * GEO_LOCATION const symbols.
 * @constant
 * @type {Object}
 */


export const GEO_LOCATION_REASONS = {
    REASON_LOGIN: 'Login',
    REASON_PERIODIC: 'Periodic',
    RETRY: 'Retry',
    AUTO_RETRY: 'Auto Retry',
};

export const GEO_LOCATION = {
    NUN: 0,
    GEO_HYBRID_ANDROID: 'HYBRID_ANDROID',
    GEO_HYBRID_IOS: 'HYBRID_IOS',
    GEO_WEBAPP_ANDROID: 'WEBAPP_ANDROID',
    GEO_WEBAPP_IOS: 'WEBAPP_IOS',
    GEO_PC: 'PC',
    GEO_MAC: 'MAC',
    RES_OK: '1',
    RES_FAILED: '0',
    USER_ID: 'userId',
    REASON: 'reason',
    PHONE: 'phone',
    LICENSE: 'license',
    SESSION_KEY: 'sessionKey',
    REASON_OPEN_REAL_GAME: 'OPEN_REAL_GAME',
    USER_ID_OK: 1,
    REASON_OK: 2,
    PHONE_OK: 4,
    LICENSE_OK: 8,
    SESSION_KEY_OK: 16,
    ALL_DATA_OK: 31,
    WIN: 'win',
    MAC: 'mac',
    GC_PLATFORM: '{{GC_PLATFORM}}',
    GC_VERSION: '{{GC_VERSION}}',
    GC_DOWNLOAD_PAGE: '{{GC_DOWNLOAD_PAGE}}',
    GC_KEY: '{{GC_KEY}}',
    GC_BROWSER: '{{GC_BROWSER}}',
    PLUGIN_NOT_UPDATED_ERROR: '615',
    ANTI_LOOP_DELAY: 10000,
    OOBEE_HINT_TITLE: 'Oobee_hint_title',
    OOBEE_HINT_TXT: 'Oobee_hint_txt',
    OOBEE_HINT_INSTALL: 'Oobee_hint_install',
    OOBEE_HINT_WAKEUP: 'Oobee_hint_wakeup',
    GA_GEO_START_GEO_PROCESS: 'Start Geo Process',
    GA_GEO_PLUGIN_ENABLE: 'plugin enable',
    GA_GEO_PLUGIN_NOT_ENABLE: 'plugin not exists/enable',
    GA_GEO_LOCATION_REQUEST_SENT: 'request for geo comply sent',
    GA_PLAYER_MESSAGES_NOT_CONNECT: 'player messages fail to connect',
    GA_GEO_LOCATION_VALIDATION: 'send platform the token received from geo comply',
    GA_GEO_LOCATION_FAIL_VALIDATE_GEO_LOCATION: 'Failed ValidateGeoLocation from platform(location manager)',
    GA_GEO_LOCATION_SUCCEEDED_VALIDATE_GEO_LOCATION: 'ok response from ValidateGeoLocation api from platform(location manager)',
    GA_GEO_LOCATION_POPUP_CLOSED: 'Geolocation in progress popup closed',
    GA_GEO_LOCATION_CATEGORY_SERVICE: 'GeoLocation Service',
    GA_GEO_LOCATION_CATEGORY_WRAPPER: 'GeoLocation',
    GA_GEO_LOCATION_KICK_EVENT: 'onGeoKickEvent',
    GA_GEO_LOCATION_KICK_EVENT_UN_KNOWN_REASON_ID: 'onGeoKickEvent was ignore, unknown reason ID',
    GA_GEO_DISABLED: 'GeoLocation feature disabled',
    GA_NO_GEO_NEEDED_ACCORDING_TO_PLATFORM_PROPERTY: 'no need for Geo now because isGeoLocationInProcess property from platform is false',
    GA_GEO_PLATFORM_ASK_GEO_VIA_LOGIN: 'Platform ask geo process via login property',
    GA_GEO_NOT_VALID_REQUEST_FROM_PLATFORM: 'invalid request from platform for geo check',
    TECHNICAL_PROBLEM_REASON: 'kick_reason_26',
    GEO_IN_PROCESS_MSG_TITLE: 'geo_location_title',
    GENERIC_OK_BUTTON: 'mdp_ok',
    GA_GEO_CLEAN_GEO_PROPERTY_FROM_LOGIN_TOKEN: 'Clean geoLocation property from login token',
    GA_GEO_SHOW_GEO_IN_PROGRESS_POPUP: 'show geo in progress popup',
    GA_GEO_GEO_COMPLY_RESULT_OK: 'geo comply result is ok',
    GA_GEO_GEO_COMPLY_RESULT_FAILED : 'geo comply result failed',
    GEO_SET_LOCATION_TIMEOUT: 'GeoLocation set timeout that will fail the geo if we do not have answer',
    GEO_SET_LOCATION_TIMEOUT_REACHED: 'geo reach timeout',
    GA_GEO_ALREADY_IN_PROCESS: "GeoLocation already in process",
    GA_RESTRICTION_CHANGE: "restriction change event from firebase called",
    GA_RETRY_NOT_ELIGIBLE: 'retry not eligible according to platform response to initGeo',
    DISRUPTIVE_WARNING_MESSAGE_NAME: "DisruptiveWarningMessage",
    DISRUPTIVE_KICKOFF_MESSAGE_NAME: "DisruptiveKickOffMessage",
    GA_GEO_LOCATION_PROCESS_FAILED: "geo location process failed",
    GA_GEO_LOCATION_PROCESS_SUCCEED: "geo location process succeed"
};